export default [
    {
        path: '/trailers',
        name: 'Trailers',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/trailers/TrailerIndex.vue'),
        },
    },
    {
        path: '/trailers/create',
        name: 'TrailerCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            title: 'Create trailer',
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/trailers/TrailerCreate.vue'),
        },
    },
    {
        path: '/trailers/:id/edit',
        name: 'TrailerEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            title: 'Edit trailer',
            denyRoles: ['SALES'],
        },
        components: {
            default: () => import('@views/trailers/TrailerEdit.vue'),
        },
    },
];
